import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.every.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import uploadfile from '@/components/mapv2/uploadfile';
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus';
import { sizeFilter, handleHttp, transformStr3, getformListItemsdatas, getFileStatus, formatToLine, formfileHandle } from "@/utils/utils";
export default {
  name: 'smconfig',
  components: {},
  meta: {
    title: '通用地图配置页'
  },
  data() {
    return {
      basicform: {
        themecolor: 'rgba(163, 2, 0, 1)'
      },
      // 基本配置
      formData: [],
      // 存放配置表单数据
      formparams: {
        deptId: '',
        formId: '349949',
        page: 1,
        limit: 100,
        searchStr: '',
        orderBy: 'manualOrderTop,manualOrder'
      },
      Indexcondition: [],
      dataList: [],
      dataTotal: 0,
      // 默认express操作符
      defalutexpress: [{
        value: '===',
        label: '等于'
      }, {
        value: '!==',
        label: '不等于'
      }],
      tabsFlag: false,
      listConfig: [],
      detailConfig: [],
      detailotherConfig: [],
      typeConfig: [],
      // 是否在首页显示字段
      showIndexOptions: [{
        value: 1,
        label: '是'
      }, {
        value: 0,
        label: '否'
      }],
      activeName: 0,
      dialogVisible: false,
      // 筛选条件弹窗/选项/索引
      conditionmarkdialog: false,
      conditionOptions: [],
      conditionIndex: '',
      completeData: [],
      reloadTimer: null,
      linkform: {
        urldomain: '',
        httpInfo: 'http://'
      },
      httpParam: [{
        label: 'http://',
        value: 'http://'
      }, {
        label: 'https://',
        value: 'https://'
      }],
      conIndex: 0,
      // 地图配置表单中是否有标题
      isHasTitle: false,
      structList: [],
      sList: [],
      basicformUserId: '',
      basicformUser: '',
      Timer: null,
      saving: false,
      indexstyleOptions: [{
        label: '样式1',
        value: 1
      }, {
        label: '样式2',
        value: 2
      }],
      indexstyle2image: {},
      configFormIdFromSearch: ''
    };
  },
  created() {
    if (process.env.NODE_ENV === 'production') this.login();
  },
  mounted() {
    document.querySelector('html').style.height = '100%';
    document.querySelector('body').style.height = '100%';
    document.querySelector('#app').style.height = '100%';
    this.getData();
    this.getConfigstruct();
  },
  computed: {
    pageQuery() {
      const searchQuery = Object.fromEntries(new URLSearchParams(window.location.search).entries());
      return {
        ...searchQuery,
        ...this.$route.query
      };
    },
    fid() {
      return this.pageQuery.fid || this.$cookie.get('wfwfid') || this.$cookie.get('fid') || '';
    },
    configFormId() {
      return this.pageQuery.formId || this.configFormIdFromSearch || this.formparams.formId || '';
    }
  },
  watch: {
    'detailConfig'(val) {
      if (val) {
        this.detailotherConfig = val.filter((val, index) => {
          return index > 1;
        });
      }
    }
  },
  methods: {
    login() {
      this.$api.autoLogin().then(res => {
        // 仅存合法 Latin-1 token，避免中文 msg（如「请先登录」）写入 Authorization 导致 setRequestHeader 报错
        if (typeof res === 'string' && res.length > 0 && /^[\x00-\xFF]+$/.test(res)) {
          localStorage.setItem('mapconfigdata', res);
        }
      });
    },
    // 左侧栏点击操作
    menuHandle(index) {
      this.conIndex = index;
    },
    // 获取地图配置表单结构
    getConfigstruct() {
      if (!this.fid) return;
      let params = {
        deptId: this.fid,
        formId: 677917
      };
      this.$api.formStruct(params).then(res => {
        if (!Array.isArray(res)) {
          ElMessage({
            message: this.formNotExistTip(params, res, '基础配置'),
            type: 'warning'
          });
          this.structList = [];
          this.sList = [];
          this.basicform.indexstyle = 1;
          return;
        }
        this.structList = JSON.parse(JSON.stringify(res));
        this.sList = this.getformatstruct(res);
        this.basicform.indexstyle = 1;
      });
    },
    getformatstruct(data) {
      return data.map(i => {
        this.basicform[i.alias] = '';
        if (i.field.defaultValueStr) {
          let idStr = i.field.defaultValueStr;
          if (idStr) {
            let dStr = idStr === '[]' ? '' : JSON.parse(idStr);
            this.basicform[i.alias] = dStr !== '' ? dStr[0].val : '';
          }
        }
        let itemObj = {
          alias: i.alias,
          compt: i.compt,
          values: getFileStatus(i) ? [] : [{
            val: ''
          }]
        };
        return itemObj;
      });
    },
    // 获取配置数据
    getData() {
      let that = this;
      this.formparams.deptId = this.fid;
      this.$api.singleadvanceSearch(this.formparams).then(res => {
        // console.log(res)
        if (!this.pageQuery.formId && res.dataList && res.dataList.length > 0 && res.dataList[0].formId) {
          this.configFormIdFromSearch = String(res.dataList[0].formId);
        }
        let formData = [];
        if (res.totalRow > 0) {
          that.Indexcondition = [];
          that.dataList = res.dataList.map(item => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
            let listparams = [];
            itemformat.listparams.split(',').forEach((items, indexs) => {
              if (items !== '') listparams.push(items.split('|')[1]);
            });
            let detailparams = [];
            itemformat.detailparams.split(',').forEach((items, indexs) => {
              if (items !== '') detailparams.push(items.split('|')[1]);
            });
            let typeparams = [];
            itemformat.typeparams.split(',').forEach((items, indexs) => {
              if (items !== '') typeparams.push(items.split('|')[1]);
            });
            // 列表、详情、分类 提取 字段别名
            item.itemformdata.listvalue = listparams;
            item.itemformdata.detailvalue = detailparams;
            item.itemformdata.type = typeparams;
            item.itemformdata.listConfig = [];
            item.itemformdata.detailConfig = [];
            item.itemformdata.typeConfig = [];
            // 处理fid/formId/name 赋值
            item.itemformdata.fid = itemformat.unitfid;
            item.itemformdata.formId = itemformat.unitformId;
            item.itemformdata.name = itemformat.title;
            item.itemformdata.location = itemformat.locationparam;
            // 处理外链字段
            if (item.itemformdata.linkparam) {
              item.itemformdata.linktype = parseInt(itemformat.linkparam.split(',')[0]);
              if (itemformat.linktype === 0) {
                item.itemformdata.pageId = itemformat.linkparam.split(',')[1];
              } else {
                item.itemformdata.link = itemformat.linkparam.split(',')[1];
              }
            }
            item.itemformdata.showParams = false;
            item.itemformdata.stepshow = true;
            item.itemformdata.isexist = true;
            item.itemformdata.id = item.id;
            // console.log(item.itemformdata)
            item.itemformdata.isShowIndex = itemformat.showIndex === '' || itemformat.showIndex === undefined ? 0 : parseInt(itemformat.showIndex);
            item.itemformdata.Indexcondition = itemformat.selectcondition === '' || itemformat.selectcondition === undefined || itemformat.selectcondition.length === 0 ? [] : JSON.parse(itemformat.selectcondition);
            // 获取对应表单字段结构，unitfid 为空则跳过，避免 deptId=
            const unitfid = String(item.itemformdata.unitfid || '').trim();
            if (!unitfid) {
              formData.push({
                form: item.itemformdata
              });
              return item;
            }
            let params = {
              deptId: unitfid,
              formId: item.itemformdata.unitformId
            };
            this.$api.formStruct(params).then(res => {
              // console.log(res)
              if (!Array.isArray(res)) {
                ElMessage({
                  message: this.formNotExistTip(params, res, item.itemformdata.name),
                  type: 'warning'
                });
                return;
              }
              let locationOptions = [];
              let typeOptions = [];
              // 用于配置页面 定位字段 显示分类选项集合
              let currentOptions = res.map(items => {
                items.value = items.alias;
                if (items.compt === 'location') locationOptions.push(items);
                if (items.compt === 'selectbox' || items.compt === 'selectmultibox' || items.compt === 'checklist') typeOptions.push(items);
                return items;
              });
              item.itemformdata.locationoptions = locationOptions;
              item.itemformdata.typeoptions = typeOptions;

              // 用于配置页面 显示当前表单字段集合
              item.itemformdata.options = currentOptions;
              // 用于配置页面 首页筛选条件（不展示relateddata、 location、 imagebox字段）
              item.itemformdata.conditionOptions = currentOptions.filter(items => {
                return items.compt !== 'relateddata' && items.compt !== 'location' && items.compt !== 'imagebox';
              });

              // 处理 页面首页筛选条件 赋值 
              let indexcondition = [];
              item.itemformdata.Indexcondition.forEach(items => {
                item.itemformdata.conditionOptions.forEach(citems => {
                  if (items.alias === citems.alias) {
                    citems.expressOptions = that.Setexpress(items.compt);
                    citems.express = items.express;
                    if (items.val) {
                      citems.selectname = items.val.length > 1 ? items.val : items.val[0];
                    }
                    if (items.range) {
                      citems.selectname = items.range;
                    }
                    indexcondition.push(citems);
                  }
                });
              });
              that.Indexcondition.push(indexcondition);
              // 用于配置页面右侧 实时显示列表字段
              item.itemformdata.listparams.split(',').forEach(items => {
                if (items !== '') {
                  let params = items.split('|');
                  currentOptions.forEach(listitem => {
                    if (params[1] === listitem.alias) {
                      item.itemformdata.listConfig.push(listitem);
                    }
                  });
                } else {
                  item.itemformdata.listConfig.push('');
                }
              });
              // 用于配置页面右侧 实时显示详情字段
              item.itemformdata.detailparams.split(',').forEach(items => {
                if (items !== '') {
                  let params = items.split('|');
                  currentOptions.forEach(detailitem => {
                    if (params[1] === detailitem.alias) {
                      item.itemformdata.detailConfig.push(detailitem);
                    }
                  });
                } else {
                  item.itemformdata.detailConfig.push('');
                }
              });
              // 用于配置页面右侧 实时显示详情字段
              item.itemformdata.typeparams.split(',').forEach(items => {
                if (items !== '') {
                  let params = items.split('|');
                  currentOptions.forEach(typeitem => {
                    if (params[1] === typeitem.alias) {
                      item.itemformdata.typeConfig.push(typeitem);
                    }
                  });
                } else {
                  item.itemformdata.typeConfig.push('');
                }
              });
            });
            formData.push({
              form: item.itemformdata
            });
            return item;
          });
          that.dataTotal = res.totalRow;
        } else {
          formData.push({
            form: {}
          });
        }
        // 等待DOM更新完成后 执行数据
        that.$nextTick(() => {
          that.formData = formData;
          if (formData.length > 0) {
            let timer = setInterval(() => {
              if (formData[0].form.listConfig) {
                that.tabsFlag = true;
                that.listConfig = formData[0].form.listConfig;
                that.detailConfig = formData[0].form.detailConfig;
                that.typeConfig = formData[0].form.typeConfig;
                // console.log(formData[0].form)
                // 通用地图基础配置 是否存在数据
                if (formData[0].form[44] && formData[0].form[44] !== '') {
                  that.isHasTitle = true;
                  that.basicformUserId = formData[0].form[44];
                  let form = {
                    deptId: this.fid,
                    formId: 677917,
                    limit: 20,
                    searchStr: '',
                    mapSettingfid: this.fid
                  };
                  this.$api.map_search(form).then(res => {
                    res.dataList.map(elem => {
                      let itemformdata = elem.formIdValueData;
                      let itemformat = {};
                      Object.keys(itemformdata).forEach(key => {
                        itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
                      });
                      elem.itemformdata = itemformat;
                      if (elem.id === parseInt(that.basicformUserId)) {
                        that.basicformUser = elem;
                        Object.keys(that.basicform).forEach(child => {
                          that.basicform[child] = elem.itemformdata[child];
                        });
                        let jsontxt = JSON.parse(that.getStr(elem.itemformdata.jsontxt));
                        let styleOption = jsontxt.styleOption;
                        that.basicform.themecolor = styleOption.themecolor;
                        that.basicform.indexstyle = styleOption.indexstyle === undefined ? 1 : styleOption.indexstyle;
                        if (styleOption.indexstyle2image !== undefined) that.basicform.indexstyle2image = styleOption.indexstyle2image;
                      }
                      return elem;
                    });
                  });
                }
                clearInterval(timer);
              }
            }, 500);
          }
        });
      });
    },
    // 添加按钮操作
    addform() {
      this.formData.push({
        form: {
          stepshow: false
        }
      });
      this.formData.forEach(item => {
        item.form.showParams = false;
      });
    },
    // 下一步操作
    tabconfirm(index) {
      let that = this;
      let currentForm = this.formData[index];
      const inputFid = String(currentForm.form.fid || '').trim();
      const inputFormId = String(currentForm.form.formId || '').trim();
      if (!inputFid) {
        ElMessage({
          message: '请输入单位fid',
          type: 'warning'
        });
        return;
      } else if (!inputFormId) {
        ElMessage({
          message: '请输入表单formId',
          type: 'warning'
        });
        return;
      } else if (currentForm.form.name == undefined || currentForm.form.name == '') {
        ElMessage({
          message: '请输入自定义标题',
          type: 'warning'
        });
        return;
      } else {
        // 获取对应表单字段结构，deptId 只用当前行输入的 fid
        let params = {
          deptId: inputFid,
          formId: inputFormId
        };
        this.$api.formStruct(params).then(res => {
          if (!Array.isArray(res)) {
            ElMessage({
              message: this.formNotExistTip(params, res, currentForm.form.name),
              type: 'warning'
            });
            return;
          }
          let locationoptions = [];
          let typeoptions = [];
          let currentOptions = res.map(item => {
            item.value = item.alias;
            if (item.compt === 'location') locationoptions.push(item);
            if (item.compt === 'selectbox') typeoptions.push(item);
            return item;
          });
          // that.formData[index].form.options = currentOptions
          // 视图刷新
          let conditionOptions = currentOptions.filter(items => {
            return items.compt !== 'relateddata' && items.compt !== 'location' && items.compt !== 'imagebox';
          });
          that.formData[index].form.options = currentOptions;
          that.formData[index].form.locationoptions = locationoptions;
          that.formData[index].form.typeoptions = typeoptions;
          that.formData[index].form.showParams = true;
          that.formData[index].form.stepshow = true;
          that.formData[index].form.conditionOptions = conditionOptions;
          that.tabsFlag = true;
          that.listConfig = [];
          that.detailConfig = [];
          that.typeConfig = [];
        });
      }
    },
    // 列表选择字段操作
    listSelect(val, index) {
      // console.log(val)
      // console.log(index)
      this.listConfig = [];
      if (val.length !== 0) {
        let listcurrentparam = [];
        val.forEach(item => {
          this.formData[index].form.options.forEach(items => {
            if (item === items.alias) {
              listcurrentparam.push(items);
            }
          });
        });
        // console.log(listcurrentparam)
        let isHasImage = listcurrentparam.find(item => item.compt === 'imagebox');
        // console.log(isHasImage)
        if (isHasImage !== undefined) {
          let ImageIndex = '';
          let ImageChild = '';
          listcurrentparam.forEach((item, indexs) => {
            if (item.compt === 'imagebox' && indexs !== 0) {
              ImageIndex = indexs;
              ImageChild = item;
            }
          });
          if (ImageChild !== '') {
            listcurrentparam[ImageIndex] = listcurrentparam[0];
            listcurrentparam[0] = ImageChild;
          }
        } else {
          listcurrentparam.unshift('');
        }
        this.listConfig = listcurrentparam;
        this.formData[index].form.listConfig = this.listConfig;
      }
    },
    // 详情选择字段操作
    detailSelect(val, index) {
      this.detailConfig = [];
      if (val.length !== 0) {
        let currentParams = [];
        val.forEach(item => {
          this.formData[index].form.options.forEach(items => {
            if (item === items.alias) {
              currentParams.push(items);
            }
          });
        });
        // console.log(currentParams)
        let isHasImage = currentParams.find(item => item.compt === 'imagebox');
        // console.log(isHasImage)
        if (isHasImage !== undefined) {
          let ImageIndex = '';
          let ImageChild = '';
          currentParams.forEach((item, indexs) => {
            if (item.compt === 'imagebox' && indexs !== 0) {
              ImageIndex = indexs;
              ImageChild = item;
            }
          });
          if (ImageChild !== '') {
            currentParams[ImageIndex] = currentParams[0];
            currentParams[0] = ImageChild;
          }
        } else {
          currentParams.unshift('');
        }
        this.detailConfig = currentParams;
        this.formData[index].form.detailConfig = this.detailConfig;
      }
    },
    locationSelect() {},
    linktype() {},
    linkSelect() {},
    // 选择类型字段操作
    typeSelect(val, index) {
      if (val.length !== 0) {
        let currentParams = [];
        val.forEach(item => {
          this.formData[index].form.options.forEach(items => {
            if (item === items.alias) {
              currentParams.push(items);
            }
          });
        });
        this.typeConfig = currentParams;
        this.formData[index].form.typeConfig = this.typeConfig;
      }
    },
    Showindexchange() {},
    // 显示筛选条件弹窗
    showcondition(index) {
      if (this.Indexcondition[index] === undefined) this.Indexcondition[index] = [];
      this.conditionOptions = this.formData[index].form.conditionOptions;
      this.conditionmarkdialog = true;
      this.conditionIndex = index;
    },
    // 选择筛选条件操作
    filterHandle(item, index) {
      // console.log(item)
      if (this.Indexcondition.length == 0) {
        item.expressOptions = this.Setexpress(item.compt);
        item.express = '';
        item.selectname = '';
        this.Indexcondition[0] = [item];
      } else {
        this.Indexcondition.forEach((citems, cindex) => {
          if (this.conditionIndex === cindex) {
            let isExist = citems.find(items => {
              return items.alias === item.alias;
            });
            if (isExist === undefined) {
              item.expressOptions = this.Setexpress(item.compt);
              item.express = '';
              item.selectname = '';
              citems.push(item);
            }
          }
        });
      }
      this.conditionmarkdialog = false;
    },
    // 选择操作符 操作
    expressSelect(val, index, cindex) {
      this.Indexcondition[index][cindex].express = val;
      this.$forceUpdate();
    },
    // 筛选值 赋值操作
    selectInputChange(val, index, cindex) {
      this.Indexcondition[index][cindex].selectname = val;
      this.$forceUpdate();
    },
    // 筛选值 下拉框等 字段 赋值操作
    expressvalueChange(val, item, index, cindex) {
      console.log(item);
      if (item.compt === 'editinput' || item.compt === 'edittextarea' || item.compt === 'numberinput' || item.compt === 'richtext') {
        this.Indexcondition[index][cindex].selectname = val;
      }
      if (item.compt === 'radiobutton' || item.compt === 'checklist' || item.compt === 'selectbox' || item.compt === 'selectmultibox' || item.compt === 'multipleselect') {
        // this.Indexcondition[index][cindex].selectname = typeof(val) === 'object' ? val : [val]
        this.Indexcondition[index][cindex].selectname = val;
      }
      if (item.compt === 'dateinput') {
        if (typeof val === 'object') {
          this.Indexcondition[index][cindex].selectname = val.map(timeitem => {
            return timeFormat(timeitem);
          });
        } else {
          this.Indexcondition[index][cindex].selectname = timeFormat(val);
        }
      }
      this.$forceUpdate();
    },
    // 删除 筛选条件操作
    IndexconditionDelete(item, index, cindex) {
      ElMessageBox.confirm('确定要删除么？', '温馨提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.Indexcondition[index].splice(cindex, 1);
        this.$forceUpdate();
      }).catch(() => {});
    },
    // 向下展开-向上收起操作
    updownHandle(item, index) {
      this.formData[index].form.showParams = !this.formData[index].form.showParams;
    },
    // 删除配置数据操作
    minusform(item, index) {
      if (this.formData.length === 1) {
        ElMessage({
          message: '至少保留一条数据',
          type: 'success'
        });
        return false;
      }
      console.log(item);
      ElMessageBox.confirm('确定要删除么？', '温馨提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        if (item.form.id !== undefined) {
          this.$api.deleteFormdata({
            formId: this.configFormId,
            formUserId: item.form.id
          }).then(res => {
            ElMessage({
              message: res,
              type: 'success'
            });
            // this.formData.splice(index, 1)
            setTimeout(() => {
              location.reload();
            }, 1500);
          });
        } else {
          this.formData.splice(index, 1);
        }
      }).catch(() => {});
    },
    // 右侧tab点击操作
    handleClick(val) {
      let currentForm = this.formData[parseInt(val.index)];
      // console.log(currentForm)
      this.listConfig = currentForm.form.listConfig;
      this.detailConfig = currentForm.form.detailConfig;
      this.typeConfig = currentForm.form.typeConfig;
    },
    // 保存设置
    sumbitSave() {
      if (this.saving) return;
      this.$refs['basicform'].validate(valid => {
        if (!valid) {
          ElMessage({
            message: '基本设置中有未填写项',
            type: 'warning'
          });
          return;
        }
        this.saving = true;
        let dataList = JSON.parse(JSON.stringify(this.sList));
        dataList = dataList.map(item => {
          let v = this.basicform[item.alias];
          // 先统一处理下basicform字段值
          if (v === '' || v.length === 0) v = '';
          if (v.length === 1 && v[0].val === '') v = '';
          item.values[0].val = v;
          if (item.compt === 'richtext') {
            let data = {
              styleOption: {
                themecolor: this.basicform.themecolor,
                indexstyle: this.basicform.indexstyle
              }
            };
            if (this.basicform.indexstyle === 2) {
              data.styleOption.indexstyle2image = this.basicform.indexstyle2image;
            }
            item.values[0].val = '<p element-id=\"init\" style="display: none;">' + JSON.stringify(data) + '</p>';
          }
          return item;
        });
        const afterBasicSave = () => {
          this.dataHandle().finally(() => {
            this.saving = false;
          });
        };
        if (!this.isHasTitle) {
          dataList = dataList.filter(item => {
            return item.values[0].val !== '';
          });
          this.$api.addFormdata({
            deptId: this.fid,
            formId: 677917,
            uid: this.pageQuery.uid
          }, encodeURI(JSON.stringify(dataList))).then(res => {
            this.basicformUserId = res.formUserId;
            this.isHasTitle = true;
            this.basicformUser = {
              formId: 677917,
              id: res.formUserId
            };
            afterBasicSave();
          }).catch(() => {
            this.saving = false;
          });
        } else {
          this.$api.editForm(this.fid, this.basicformUserId, encodeURI(JSON.stringify(dataList)), this.basicformUser.formId).then(() => {
            afterBasicSave();
          }).catch(() => {
            this.saving = false;
          });
        }
      });
    },
    dataHandle() {
      this.completeData = [];
      const tasks = [];
      this.formData.forEach((item, index) => {
        if (item.form.isexist !== undefined && item.form.isexist) {
          let paramsdata = this.setparamsdata(item, index);
          tasks.push(this.$api.editForm(this.fid, item.form.id, encodeURI(JSON.stringify(paramsdata)), this.configFormId).then(res => {
            ElMessage({
              message: res,
              type: 'success'
            });
            this.completeData.push(true);
          }));
        } else if (item.form.detailvalue && item.form.detailvalue.length > 0 && item.form.listvalue && item.form.listvalue.length > 0) {
          let paramsdata = this.setparamsdata(item, index);
          tasks.push(this.$api.addFormdata({
            deptId: this.fid,
            formId: this.formparams.formId,
            uid: this.pageQuery.uid
          }, encodeURI(JSON.stringify(paramsdata))).then(res => {
            item.form.id = res.formUserId;
            item.form.isexist = true;
            ElMessage({
              message: '添加成功',
              type: 'success'
            });
            this.completeData.push(true);
          }));
        } else {
          ElMessage({
            message: '第' + (index + 1) + '条数据还未填写完整',
            type: 'error'
          });
        }
      });
      this.reloadData();
      return Promise.all(tasks);
    },
    reloadData() {
      this.reloadTimer = setInterval(() => {
        if (this.completeData.length === this.formData.length) {
          let alltrue = this.completeData.every(item => {
            if (item === false) return false;
            return true;
          });
          if (alltrue) {
            // setTimeout(() => {
            //     location.reload()
            // }, 1500)
          }
          clearInterval(this.reloadTimer);
        }
      }, 1000);
    },
    setparamsdata(item, index) {
      let listparams = [];
      item.form.listConfig.forEach((items, indexs) => {
        items !== '' ? listparams.push(items.label + '|' + items.alias) : listparams.push('');
      });
      let detailparams = [];
      item.form.detailConfig.forEach((items, indexs) => {
        items !== '' ? detailparams.push(items.label + '|' + items.alias) : detailparams.push('');
      });
      let typeparams = [];
      if (item.form.typeConfig !== undefined) {
        item.form.typeConfig.forEach((items, indexs) => {
          items !== '' ? typeparams.push(items.label + '|' + items.alias) : typeparams.push('');
        });
      }

      // 在首页过滤筛选条件
      item.form.Indexcondition = [];
      console.log(this.Indexcondition);
      if (this.Indexcondition[index]) {
        this.Indexcondition[index].forEach((items, indexs) => {
          let itemsObj = {
            alias: items.alias,
            compt: items.compt,
            express: items.express
          };
          if (items.express !== '><') {
            // console.log(items.comp === 'selectbox')
            itemsObj.val = items.selectname;
            // console.log(itemsObj.val)
          } else {
            itemsObj.range = items.selectname;
          }
          item.form.Indexcondition.push(itemsObj);
        });
      }
      // console.log(item.form)
      let paramsdata = [{
        'alias': 'onlyId',
        'compt': 'editinput',
        'values': [{
          'val': index
        }]
      }, {
        'alias': 'unitfid',
        'compt': 'editinput',
        'values': [{
          'val': item.form.fid
        }]
      }, {
        'alias': 'unitformId',
        'compt': 'editinput',
        'values': [{
          'val': item.form.formId
        }]
      }, {
        'alias': 'title',
        'compt': 'editinput',
        'values': [{
          'val': item.form.name
        }]
      }, {
        'alias': 'listparams',
        'compt': 'editinput',
        'values': [{
          'val': listparams.join(',')
        }]
      }, {
        'alias': 'detailparams',
        'compt': 'editinput',
        'values': [{
          'val': detailparams.join(',')
        }]
      }, {
        'alias': 'locationparam',
        'compt': 'editinput',
        'values': [{
          'val': item.form.location !== undefined ? item.form.location : ''
        }]
      }, {
        'alias': 'linkparam',
        'compt': 'editinput',
        'values': [{
          'val': item.form.linktype !== undefined ? parseInt(item.form.linktype) === 0 ? `${item.form.linktype},${item.form.pageId}` : `${item.form.linktype},${item.form.link}` : ''
        }]
      }, {
        'alias': 'typeparams',
        'compt': 'editinput',
        'values': [{
          'val': typeparams.length > 0 ? typeparams.join(',') : ''
        }]
      }, {
        'alias': 'showIndex',
        'compt': 'editinput',
        'values': [{
          'val': item.form.isShowIndex !== undefined ? item.form.isShowIndex : ''
        }]
      }, {
        'alias': 'selectcondition',
        'compt': 'editinput',
        'values': [{
          'val': item.form.Indexcondition !== undefined ? JSON.stringify(item.form.Indexcondition) : ''
        }]
      }, {
        'alias': '44',
        'compt': 'numberinput',
        'values': [{
          'val': this.basicformUserId,
          'realNumVal': this.basicformUserId
        }]
      }, {
        'alias': '45',
        'compt': 'editinput',
        'values': [{
          'val': this.basicform.title
        }]
      }];
      // console.log(paramsdata)
      return paramsdata;
    },
    // 处理express操作符
    Setexpress(val) {
      let currentExpress = JSON.parse(JSON.stringify(this.defalutexpress));
      // 是数字类型字段或日期类型
      if (val === 'numberinput' || val === 'dateinput') {
        let numberdateexpress = [{
          value: '>',
          label: '大于'
        }, {
          value: '>=',
          label: '大于等于'
        }, {
          value: '<',
          label: '小于'
        }, {
          value: '<=',
          label: '小于等于'
        }, {
          value: '><',
          label: '选择范围'
        }];
        numberdateexpress.forEach(items => {
          currentExpress.push(items);
        });
      } else {
        let nonumberdateexpress = [{
          value: 'like',
          label: '包含'
        }, {
          value: 'notLike',
          label: '不包含'
        }];
        nonumberdateexpress.forEach(items => {
          currentExpress.push(items);
        });
      }
      // 是单选，多选，联系人，部门字段
      if (val === 'radiobutton' || val === 'checklist' || val === 'contact' || val == 'department') {
        let otherexpress = [{
          value: 'match',
          label: '等于任意一个'
        }, {
          value: 'notMatch',
          label: '不等于任意一个'
        }, {
          value: 'allMatch',
          label: '同时包含'
        }];
        otherexpress.forEach(items => {
          currentExpress.push(items);
        });
      }
      return currentExpress;
    },
    getStr(str) {
      return str.replace(/(<\/?p.*?>)/gi, '');
    },
    formNotExistTip(params, res, title) {
      const reason = typeof res === 'string' && res ? res : '表单不存在';
      const formId = params && params.formId || '';
      const fid = params && params.deptId || '';
      const name = title ? `${title}，` : '';
      return `${reason}（${name}formId：${formId}，fid：${fid}）`;
    },
    // 页面生成链接
    golink(val) {
      // console.log(val)
      this.dialogVisible = true;
      let query = {
        ...this.pageQuery
      };
      if (!query.fid) {
        query.fid = this.fid;
      }
      query.relationto = this.linkform.urldomain !== '' ? encodeURIComponent(this.linkform.httpInfo + this.linkform.urldomain) : '';
      // 广东工业大学(fid=378)：地图单页走 T2 样式页
      let path = val;
      if (val === 'sdmap' && String(query.fid) === '378') {
        path = 'sdmapT2';
      }
      this.$router.push({
        path: '/' + path,
        query
      });
    },
    selectindexstyle(val) {
      console.log(val);
    },
    fileListHandle(val, title) {
      this.basicform.indexstyle2image = formfileHandle(val, 'imagebox', this.pageQuery.uid);
    }
  }
};